import React from 'react';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import Modal from '../../../../components/Modal';
import useOrders from '../../../../hooks/useOrders';

interface Props {
  open: boolean;
  onClose: () => void;
  orderId: string;
  activeDelivererId?: string; // Add this line
  handleSetStatus: (
    table_id: string,
    status_id: number,
    isPickedUp?: boolean,
  ) => void;
  statusId: number;
}
function OrderApproveModal({
  open,
  onClose,
  orderId,
  activeDelivererId, // Add this line
  handleSetStatus,
  statusId,
}: Props) {
  const { t } = useTranslation('orders');
  const { enqueueSnackbar } = useSnackbar();
  const { orderApprove } = useOrders();

  const handleApprove = async () => {
    try {
      await orderApprove(orderId);
      enqueueSnackbar('İşleminiz Onaylandı.', { variant: 'success' });
      onClose();
    } catch (err) {
      enqueueSnackbar('Onaylama İşleminiz Başarısız.', { variant: 'error' });
    }
  };

  return (
    <Modal
      maxWidth="md"
      open={open}
      onClose={onClose}
      title="Task Onayı"
      positiveAction="Onayla"
      negativeAction={t('order.deliverer_modal.close')}
      onPositiveClick={handleApprove}
    >
      Taskı onaylamak istediğinizden emin misiniz?
    </Modal>
  );
}

export default OrderApproveModal;
